import { makeAutoObservable, observable } from 'mobx'

import { DatumItem } from '../models/getProducts'

class AddToCart {
  cartlist: Array<CartItem> = []
  constructor() {
    makeAutoObservable(this, { cartlist: observable })
  }
  async add(item: DatumItem, restaurantId: string, groupId: string) {
    console.log(restaurantId, groupId)

    var cartItem: CartItem = {
      id: item.objectId,
      product: item,
      count: 1,
      restaurantId: restaurantId,
      groupId: restaurantId + groupId,
    }
    if (this.cartlist.length === 0) {
      this.cartlist.push(cartItem)
      return
    } else {
      for (let index = 0; index < this.cartlist.length; index++) {
        const element = this.cartlist[index]
        if (element.id === item.objectId) {
          this.cartlist[index].count++
          return
        }
      }
      if (this.cartlist[0].groupId.includes(restaurantId)) {
        this.cartlist.push(cartItem)
      } else {
        alert('You can only add items from a group restuarant')
      }
    }
  }
  get() {
    return this.cartlist
  }
  async reduce(id: string) {
    for (let index = 0; index < this.cartlist.length; index++) {
      const element = this.cartlist[index]
      if (element.id === id) {
        if (this.cartlist[index].count === 1) {
          this.cartlist.splice(index, 1)
          return
        }
        this.cartlist[index].count--
      }
    }
  }

  getSubtotal() {
    let subtotal = 0
    this.cartlist.forEach((item) => {
      subtotal += item.product.price.amount * item.count
    })
    return subtotal
  }
}

export const addToCart = new AddToCart()

interface CartItem {
  id: string
  product: DatumItem
  count: number
  restaurantId: string
  groupId: string
}
